export default __webpack_public_path__ + "static/media/detail_big_13_6.8a8ea4e8.jpg";